import { Injectable } from '@angular/core';
import { ChatAction, ChatItem } from '../../../models/chat-ui.model';
import { CsvTaskSystemMessage } from '../api/csv-task-polling.service';
import { ChatMessageTextService } from './chat-message-text.service';

@Injectable({
  providedIn: 'root'
})
export class ChatActionBuilderService {
  constructor(private messageText: ChatMessageTextService) {}

  buildTaskAction(taskId: string): ChatAction {
    return { kind: 'task', label: `Abrir tarea ${taskId}`, taskId };
  }

  buildExternalAction(href: string, label: string): ChatAction | null {
    if (!this.isSafeExternalUrl(href)) {
      return null;
    }

    return { kind: 'external', label, href };
  }

  buildCsvPollingMessage(msg: CsvTaskSystemMessage, entityId: string): ChatItem {
    const extractedTaskId = this.extractTaskId(msg.text || '');
    const effectiveTaskId = msg.taskId || extractedTaskId;
    const actions: ChatAction[] = [];

    if (effectiveTaskId) {
      actions.push(this.buildTaskAction(effectiveTaskId));
    }

    if (msg.resultUrl) {
      const externalAction = this.buildExternalAction(msg.resultUrl, msg.resultLabel || 'Ver resultado');
      if (externalAction) {
        actions.push(externalAction);
      }
    }

    return {
      type: 'system',
      content: this.messageText.normalize(msg.text || ''),
      timestamp: new Date(),
      entityId,
      id: effectiveTaskId ? `task/${effectiveTaskId}` : undefined,
      actions: actions.length > 0 ? actions : undefined
    };
  }

  private extractTaskId(text: string): string | null {
    const match = /task[_-]?id(?:\s*[:=]?\s*)([\w.-]+)/i.exec(text.toString());
    return match?.[1] || null;
  }

  private isSafeExternalUrl(value: string): boolean {
    try {
      const url = new URL(value, globalThis.location?.origin ?? 'http://localhost');
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
      return false;
    }
  }
}
